import React, { Fragment } from 'react';
import { grayDarker, sansSerif } from 'styles/css-constants';

// prettier-ignore
const AFFILIATE_DISCLAIMER = 'We independently select these products&mdash;if you buy from one of our links, we may earn a commission.';

function AffiliateMessage() {
  return (
    <Fragment>
      <div
        className="AffiliateMessage"
        dangerouslySetInnerHTML={{ __html: AFFILIATE_DISCLAIMER }}
      />
      <style jsx>{`
        color: ${grayDarker};
        font-family: ${sansSerif};
        font-size: var(--fontScaleNeg1);
        font-style: italic;
        line-height: 1.3;
      `}</style>
    </Fragment>
  );
}

export default AffiliateMessage;
